{
  "users": {
    "label": "Usuarios"
  },
  "userGroups": {
    "label": "Grupos"
  },
  "userProfiles": {
    "label": "Perfiles"
  }
}
